import React, { PropsWithChildren } from 'react';
import { Box, responsive } from '@vp/swan';

const ResponsiveBox = responsive(Box);

export default function StepDescriptionBox({
    children,
    isModal,
    isIntelligentBrief = false,
}: PropsWithChildren & { isModal: boolean; isIntelligentBrief?: boolean }) {
    return (
        <ResponsiveBox
            textAlign="left"
            mt={2}
            style={{
                maxWidth: isModal ? undefined : isIntelligentBrief ? '300px' : '180px',
            }}
            sm={{
                textAlign: isModal ? 'left' : 'center',
            }}
            md={{
                textAlign: 'left',
            }}
        >
            {children}
        </ResponsiveBox>
    );
}
